angular.module('elfium').controller('userDetailModalController', ['$scope', '$uibModalInstance', '$timeout', 'userService', 'elfiumToastrService', 'elfiumModalFactory', 'elfiumMissingRequiredFieldsFilter', 'userId', 'elfiumPageAccessService', 'USER_REQUIRED_FIELDS', 'ELFIUM_USER_TYPES', 'PAGE',
    function ($scope, $uibModalInstance, $timeout, userService, elfiumToastrService, elfiumModalFactory, elfiumMissingRequiredFieldsFilter, userId, elfiumPageAccessService, USER_REQUIRED_FIELDS, ELFIUM_USER_TYPES, PAGE) {
        var that = this;
        that.elfiumModal = null;
        $scope.userTypes = ELFIUM_USER_TYPES;
        $scope.page = PAGE;
        that.init = function () {
            userService.getUser(userId).then(function (user) {
                $scope.user = user;
                that.elfiumModal = new elfiumModalFactory($scope, $uibModalInstance, user);
            }, elfiumToastrService.error);
        };
        that.updateUser = function () {
            userService.updateUser($scope.user).then(function () {
                that.elfiumModal.mainObjectSaved();
                elfiumToastrService.success('Uživatel byl uložen!');
                $uibModalInstance.close();
            }, elfiumToastrService.error);
        };
        $scope.okClicked = function () {
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.user, USER_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                } else {
                    that.updateUser();
                }
            });
        };
        $scope.isChecked = function (pageName) {
            return $scope.user && elfiumPageAccessService.canAccessPage(pageName, $scope.user.pageAccess);
        };
        $scope.toggleAccess = function (pageName) {
            if ($scope.isChecked(pageName)) {
                $scope.user.pageAccess = elfiumPageAccessService.removeAccessToPage(pageName, $scope.user.pageAccess);
            } else {
                $scope.user.pageAccess = elfiumPageAccessService.addAccessToPage(pageName, $scope.user.pageAccess);
            }
        };
        that.init();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/user/userDetailModalController.ts